import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  "aria-label": "breadcrumb",
  class: "mt-5 pt-5 ps-3"
}
const _hoisted_2 = { class: "breadcrumb mb-3" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "card-header d-flex justify-content-between align-items-center" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "card-body" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "table-responsive theme-scrollbar" }
const _hoisted_17 = { class: "table table-hover" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  colspan: 9,
  class: "text-center py-4"
}
const _hoisted_21 = { class: "text-center py-5" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = { class: "text-muted" }
const _hoisted_25 = { class: "text-primary" }
const _hoisted_26 = { class: "badge bg-info" }
const _hoisted_27 = { class: "badge bg-primary" }
const _hoisted_28 = { class: "badge bg-secondary" }
const _hoisted_29 = { class: "badge bg-warning text-dark" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "d-flex gap-1 justify-content-end" }
const _hoisted_32 = ["onClick", "disabled"]
const _hoisted_33 = ["onClick", "disabled"]
const _hoisted_34 = ["onClick", "title", "disabled"]
const _hoisted_35 = ["onClick", "disabled"]
const _hoisted_36 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center mt-3"
}
const _hoisted_37 = { class: "text-muted" }
const _hoisted_38 = { class: "pagination pagination-sm mb-0" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = { class: "modal-dialog" }
const _hoisted_41 = { class: "modal-content" }
const _hoisted_42 = { class: "modal-body" }
const _hoisted_43 = { class: "modal-footer" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { key: 1 }

import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import apiService from "@/services/apiService";
import { usePermissions } from "@/composables/usePermissions";
import { Modal } from "bootstrap";


export default /*@__PURE__*/_defineComponent({
  __name: 'AgentsList',
  setup(__props) {

const { canView, canCreate, canUpdate, canDelete } = usePermissions();

// Router
const router = useRouter();

// Data
const agents = ref<any[]>([]);
const isLoading = ref(false);
const searchQuery = ref("");
const filterStatus = ref("");
const filterModel = ref("");
const currentPage = ref(1);
const pageSize = ref(10);
const totalCount = ref(0);
const totalPages = ref(0);

// Delete modal
const agentToDelete = ref<any>(null);
const deleteModalRef = ref<HTMLElement | null>(null);
const isDeleting = ref(false);

// Computed
const visiblePages = computed(() => {
  const pages: number[] = [];
  const maxVisible = 5;
  let start = Math.max(1, currentPage.value - Math.floor(maxVisible / 2));
  const end = Math.min(totalPages.value, start + maxVisible - 1);

  if (end - start < maxVisible - 1) {
    start = Math.max(1, end - maxVisible + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return pages;
});

// Methods
const loadAgents = async () => {
  isLoading.value = true;
  try {
    const params: Record<string, any> = {
      page: currentPage.value,
      limit: pageSize.value,
    };

    if (searchQuery.value) {
      params.search = searchQuery.value;
    }

    if (filterStatus.value === "active") {
      params.isActive = true;
    } else if (filterStatus.value === "inactive") {
      params.isActive = false;
    }

    if (filterModel.value) {
      params.model = filterModel.value;
    }

    const response = await apiService.getAgents(params);

    if (response) {
      agents.value = response.data || response.agents || [];
      totalCount.value = response.total || response.totalCount || 0;
      totalPages.value = Math.ceil(totalCount.value / pageSize.value);
    }
  } catch (err: any) {
    console.error("Error loading agents:", err);
    showToast(err?.response?.data?.message || "Failed to load agents", "error");
  } finally {
    isLoading.value = false;
  }
};

const handleSearch = () => {
  currentPage.value = 1;
  loadAgents();
};

const changePage = (page: number) => {
  if (page < 1 || page > totalPages.value) return;
  currentPage.value = page;
  loadAgents();
};

const toggleAgentStatus = async (agent: any) => {
  
  const currentStatus = agent.is_active ?? agent.isActive;
  const newStatus = !currentStatus;
  const action = newStatus ? "activate" : "deactivate";
  const payload = {
    is_active: newStatus,
  }

  if (!confirm(`Are you sure you want to ${action} agent "${agent.name}"?`)) {
    return;
  }

  try {
    await apiService.updateAgent(agent._id || agent.id, payload);
    showToast(`Agent ${action}d successfully`, "success");
    loadAgents();
  } catch (err: any) {
    console.error(`Error toggling agent status:`, err);
    showToast(
      err?.response?.data?.message || `Failed to ${action} agent`,
      "error"
    );
  }
};

const confirmDelete = (agent: any) => {
  agentToDelete.value = agent;
  // Use Bootstrap modal
  const modalElement = deleteModalRef.value;
  if (modalElement) {
    const modal = new Modal(modalElement);
    modal.show();
  }
};

const deleteAgent = async () => {
  if (!agentToDelete.value) return;

  isDeleting.value = true;
  try {
    await apiService.deleteAgent(
      agentToDelete.value._id || agentToDelete.value.id
    );
    showToast("Agent deleted successfully", "success");

    // Close modal
    const modalElement = deleteModalRef.value;
    if (modalElement) {
      const modal = Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }

    // Reload agents
    agentToDelete.value = null;
    loadAgents();
  } catch (err: any) {
    console.error("Error deleting agent:", err);
    showToast(
      err?.response?.data?.message || "Failed to delete agent",
      "error"
    );
  } finally {
    isDeleting.value = false;
  }
};

const truncateText = (text: string, maxLength: number): string => {
  if (!text) return "";
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};

const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  return date.toLocaleDateString();
};

const getToolsCount = (tools: any): number => {
  if (!tools) return 0;
  if (Array.isArray(tools)) return tools.length;
  return 0;
};

const getKnowledgeBasesCount = (kbIds: any): number => {
  if (!kbIds) return 0;
  if (Array.isArray(kbIds)) return kbIds.length;
  return 0;
};

const showToast = (message: string, type: "success" | "error" | "info") => {
  console.log(`[${type.toUpperCase()}] ${message}`);
  // Integrate with your toast library here
};

// Lifecycle
onMounted(() => {
  loadAgents();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("li", {
          class: "breadcrumb-item active",
          "aria-current": "page"
        }, "Agents", -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[10] || (_cache[10] = _createElementVNode("div", null, [
                _createElementVNode("h5", { class: "mb-1" }, "Agents Management"),
                _createElementVNode("small", { class: "text-muted" }, " Manage AI agents, their configurations, and assignments ")
              ], -1)),
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/admin/agents/new'))),
                class: "btn btn-primary btn-sm",
                disabled: !_unref(canCreate)('agents')
              }, [...(_cache[9] || (_cache[9] = [
                _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                _createTextVNode(" Create Agent ", -1)
              ]))], 8, _hoisted_9)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "input-group-text" }, [
                      _createElementVNode("i", { class: "fa fa-search" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control",
                      placeholder: "Search agents...",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchQuery).value = $event)),
                      onInput: handleSearch
                    }, null, 544), [
                      [_vModelText, searchQuery.value]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filterStatus).value = $event)),
                    onChange: loadAgents
                  }, [...(_cache[12] || (_cache[12] = [
                    _createElementVNode("option", { value: "" }, "All Status", -1),
                    _createElementVNode("option", { value: "active" }, "Active", -1),
                    _createElementVNode("option", { value: "inactive" }, "Inactive", -1)
                  ]))], 544), [
                    [_vModelSelect, filterStatus.value]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("select", {
                    class: "form-select",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterModel).value = $event)),
                    onChange: loadAgents
                  }, [...(_cache[13] || (_cache[13] = [
                    _createStaticVNode("<option value=\"\" data-v-c70150dc>All Models</option><option value=\"gpt-4\" data-v-c70150dc>GPT-4</option><option value=\"gpt-3.5-turbo\" data-v-c70150dc>GPT-3.5 Turbo</option><option value=\"claude-3-opus\" data-v-c70150dc>Claude 3 Opus</option><option value=\"claude-3-sonnet\" data-v-c70150dc>Claude 3 Sonnet</option>", 5)
                  ]))], 544), [
                    [_vModelSelect, filterModel.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("table", _hoisted_17, [
                  _cache[22] || (_cache[22] = _createElementVNode("thead", { class: "table-dark" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { style: {"min-width":"200px"} }, "Name"),
                      _createElementVNode("th", { style: {"min-width":"200px"} }, "Slug"),
                      _createElementVNode("th", { style: {"min-width":"150px"} }, "Model"),
                      _createElementVNode("th", { style: {"min-width":"150px"} }, "Status"),
                      _createElementVNode("th", { style: {"min-width":"150px"} }, "Assignments"),
                      _createElementVNode("th", { style: {"min-width":"100px"} }, "Tools"),
                      _createElementVNode("th", { style: {"min-width":"200px"} }, "Knowledge Bases"),
                      _createElementVNode("th", { style: {"min-width":"150px"} }, "Created"),
                      _createElementVNode("th", {
                        style: {"min-width":"300px"},
                        class: "text-end"
                      }, "Actions")
                    ])
                  ], -1)),
                  (isLoading.value)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [...(_cache[14] || (_cache[14] = [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            colspan: 9,
                            class: "text-center py-4"
                          }, [
                            _createElementVNode("div", {
                              class: "spinner-border text-primary",
                              role: "status"
                            }, [
                              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                            ])
                          ])
                        ], -1)
                      ]))]))
                    : (!agents.value || agents.value.length === 0)
                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _cache[16] || (_cache[16] = _createElementVNode("i", { class: "fa fa-robot fa-3x text-muted mb-3" }, null, -1)),
                                _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-muted" }, "No agents found", -1)),
                                _createElementVNode("button", {
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(router).push('/admin/agents/new'))),
                                  class: "btn btn-primary btn-sm",
                                  disabled: !_unref(canCreate)('agents')
                                }, [...(_cache[15] || (_cache[15] = [
                                  _createElementVNode("i", { class: "fa fa-plus me-1" }, null, -1),
                                  _createTextVNode(" Create Your First Agent ", -1)
                                ]))], 8, _hoisted_22)
                              ])
                            ])
                          ])
                        ]))
                      : ( agents.value.length > 0)
                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(agents.value, (agent) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: agent._id || agent.id
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("strong", null, _toDisplayString(agent.name), 1),
                                  _cache[18] || (_cache[18] = _createElementVNode("br", null, null, -1)),
                                  _createElementVNode("small", _hoisted_24, _toDisplayString(truncateText(agent.description, 50)), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("code", _hoisted_25, _toDisplayString(agent.slug), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_26, _toDisplayString(agent.model), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass([
                            'badge',
                            agent.is_active ?? agent.isActive
                              ? 'bg-success'
                              : 'bg-secondary',
                          ])
                                  }, _toDisplayString(agent.is_active ?? agent.isActive
                              ? "Active"
                              : "Inactive"), 3)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_27, _toDisplayString(agent.assignments_count ||
                            agent.assignmentsCount ||
                            0), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_28, _toDisplayString(getToolsCount(
                              agent.tools_allowed || agent.toolsAllowed
                            )), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("span", _hoisted_29, _toDisplayString(getKnowledgeBasesCount(
                              agent.knowledge_base_ids || agent.knowledgeBaseIds
                            )), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("small", null, _toDisplayString(formatDate(agent.created_at || agent.createdAt)), 1)
                                ]),
                                _createElementVNode("td", _hoisted_30, [
                                  _createElementVNode("div", _hoisted_31, [
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_unref(router).push(`/admin/agents/${agent._id || agent.id}`)),
                                      class: "btn btn-sm btn-outline-primary",
                                      title: "View Details",
                                      disabled: !_unref(canView)('agents')
                                    }, [...(_cache[19] || (_cache[19] = [
                                      _createElementVNode("i", { class: "fa fa-eye" }, null, -1)
                                    ]))], 8, _hoisted_32),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_unref(router).push(`/admin/agents/${agent._id || agent.id}/edit`)),
                                      class: "btn btn-sm btn-outline-secondary",
                                      title: "Edit",
                                      disabled: !_unref(canUpdate)('agents')
                                    }, [...(_cache[20] || (_cache[20] = [
                                      _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                                    ]))], 8, _hoisted_33),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (toggleAgentStatus(agent)),
                                      class: "btn btn-sm btn-outline-warning",
                                      title: 
                              agent.is_active ?? agent.isActive
                                ? 'Deactivate'
                                : 'Activate'
                            ,
                                      disabled: !_unref(canUpdate)('agents')
                                    }, [
                                      _createElementVNode("i", {
                                        class: _normalizeClass([
                                'fa',
                                agent.is_active ?? agent.isActive
                                  ? 'fa-pause'
                                  : 'fa-play',
                              ])
                                      }, null, 2)
                                    ], 8, _hoisted_34),
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (confirmDelete(agent)),
                                      class: "btn btn-sm btn-outline-danger",
                                      title: "Delete",
                                      disabled: !_unref(canDelete)('agents')
                                    }, [...(_cache[21] || (_cache[21] = [
                                      _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                                    ]))], 8, _hoisted_35)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true)
                ])
              ]),
              (totalPages.value > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                    _createElementVNode("div", null, [
                      _createElementVNode("small", _hoisted_37, " Showing " + _toDisplayString((currentPage.value - 1) * pageSize.value + 1) + " to " + _toDisplayString(Math.min(currentPage.value * pageSize.value, totalCount.value)) + " of " + _toDisplayString(totalCount.value) + " agents ", 1)
                    ]),
                    _createElementVNode("nav", null, [
                      _createElementVNode("ul", _hoisted_38, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: currentPage.value === 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            href: "#",
                            onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (changePage(currentPage.value - 1)), ["prevent"]))
                          }, " Previous ")
                        ], 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: page,
                            class: _normalizeClass(["page-item", { active: currentPage.value === page }])
                          }, [
                            _createElementVNode("a", {
                              class: "page-link",
                              href: "#",
                              onClick: _withModifiers(($event: any) => (changePage(page)), ["prevent"])
                            }, _toDisplayString(page), 9, _hoisted_39)
                          ], 2))
                        }), 128)),
                        _createElementVNode("li", {
                          class: _normalizeClass(["page-item", { disabled: currentPage.value === totalPages.value }])
                        }, [
                          _createElementVNode("a", {
                            class: "page-link",
                            href: "#",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (changePage(currentPage.value + 1)), ["prevent"]))
                          }, " Next ")
                        ], 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: "modal fade",
      id: "deleteModal",
      tabindex: "-1",
      ref_key: "deleteModalRef",
      ref: deleteModalRef
    }, [
      _createElementVNode("div", _hoisted_40, [
        _createElementVNode("div", _hoisted_41, [
          _cache[29] || (_cache[29] = _createElementVNode("div", { class: "modal-header" }, [
            _createElementVNode("h5", { class: "modal-title" }, "Confirm Delete"),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal"
            })
          ], -1)),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("p", null, [
              _cache[23] || (_cache[23] = _createTextVNode(" Are you sure you want to delete agent ", -1)),
              _createElementVNode("strong", null, _toDisplayString(agentToDelete.value?.name), 1),
              _cache[24] || (_cache[24] = _createTextVNode("? ", -1))
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "text-danger" }, [
              _createElementVNode("i", { class: "fa fa-exclamation-triangle me-1" }),
              _createTextVNode(" This action cannot be undone. All assignments will be removed. ")
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_43, [
            _cache[28] || (_cache[28] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, " Cancel ", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-danger",
              onClick: deleteAgent,
              disabled: isDeleting.value
            }, [
              (isDeleting.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_45, [...(_cache[26] || (_cache[26] = [
                    _createElementVNode("span", {
                      class: "spinner-border spinner-border-sm me-1",
                      role: "status"
                    }, null, -1),
                    _createTextVNode(" Deleting... ", -1)
                  ]))]))
                : (_openBlock(), _createElementBlock("span", _hoisted_46, [...(_cache[27] || (_cache[27] = [
                    _createElementVNode("i", { class: "fa fa-trash me-1" }, null, -1),
                    _createTextVNode(" Delete ", -1)
                  ]))]))
            ], 8, _hoisted_44)
          ])
        ])
      ])
    ], 512)
  ]))
}
}

})